// extracted by mini-css-extract-plugin
module.exports = {"sideproject":"development_sideproject__EdS8T"};